import React, { useEffect, useState, useRef } from 'react';
// import 'codemirror-minimap';
// import 'codemirror-minimap/src/minimap.css';
// import './CodemirrorImports';
//
// import '../../../styles/codeEditor.css';

import Editor from '@monaco-editor/react';

interface EditorProps {
	codeText: string;
	theme: string;
	editorLang: string;
	handleChange: any;
}

const MonacoEditor: React.FC<EditorProps> = ({
	codeText,
	handleChange,
	theme,
	editorLang,
}) => {
	const [editorInstance, setEditorInstance] = useState(null);
	console.log('THEME', theme);

	const editorRef = useRef(null);

	// function handleEditorDidMount(editor, monaco) {
	// 	editorRef.current = editor;
	// }
	//
	// function showValue() {
	// 	alert(editorRef.current.getValue());
	// }
	//
	// const monacoRef = useRef(null);
	//
	// function handleEditorWillMount(monaco) {
	// 	// here is the monaco instance
	// 	// do something before editor is mounted
	// 	monaco.languages.typescript.javascriptDefaults.setEagerModelSync(true);
	// }
	//
	// function handleEditorDidMount(editor, monaco) {
	// 	// here is another way to get monaco instance
	// 	// you can also store it in `useRef` for further usage
	// 	monacoRef.current = editor;
	// }

	return (
		<div className={'code-editor'}>
			<Editor
				className={'main-editor'}
				height="100vh"
				defaultLanguage={'java'}
				language={editorLang}
				value={codeText}
				onChange={handleChange}
				theme={theme}
				// beforeMount={handleEditorWillMount}
				// onMount={handleEditorDidMount}
			/>
			{/*<CodeMirror*/}
			{/*  value={codeText}*/}
			{/*  editorDidMount={(editor) => {*/}
			{/*    //   handleEditorDidMount(editor);*/}
			{/*    editor.setSize("", "100%");*/}
			{/*  }}*/}
			{/*  options={{*/}
			{/*    mode: editorLang,*/}
			{/*    theme: theme,*/}
			{/*    minimap: { scale: 8 },*/}
			{/*    lineNumbers: true,*/}
			{/*    lint: true,*/}
			{/*    lineWrapping: true,*/}
			{/*    keyMap: "sublime",*/}
			{/*    tabSize: 4,*/}
			{/*    matchBrackets: true,*/}
			{/*    styleActiveLine: { nonEmpty: true },*/}
			{/*    styleActiveSelected: true,*/}
			{/*    smartIndent: true,*/}
			{/*    highlightSelectionMatches: {*/}
			{/*      // showToken: /\w/,*/}
			{/*      annotateScrollbar: true*/}
			{/*    },*/}
			{/*    autoCloseBrackets: true,*/}
			{/*    extraKeys: {*/}
			{/*      "Ctrl-Q": function(cm: any) {*/}
			{/*        cm.foldCode(cm.getCursor());*/}
			{/*      },*/}

			{/*      "Ctrl-/": function(cm: any) {*/}
			{/*        cm.execCommand(cm.toggleComment());*/}
			{/*      },*/}
			{/*      "Ctrl-Space": "autocomplete"*/}
			{/*    },*/}
			{/*    foldGutter: true,*/}
			{/*    gutters: [*/}
			{/*      "CodeMirror-linenumbers",*/}
			{/*      "CodeMirror-foldgutter",*/}
			{/*      "CodeMirror-lint-markers"*/}
			{/*    ]*/}
			{/*  }}*/}
			{/*  onBeforeChange={(editor, data, value) => {*/}
			{/*    // setReset(false);*/}
			{/*    setCodeText(value);*/}
			{/*  }}*/}
			{/*/>*/}
		</div>
	);
};

export default MonacoEditor;
